import {getUseChannelCatalogList} from 'views/programming/channel/edit/catalog/hooks/getUseChannelCatalogList';
import {useMemoryQueueApi} from 'views/programming/channel/edit/catalog/hooks/useMemoryQueueApi';

export const useChannelCatalogQueue = getUseChannelCatalogList(useMemoryQueueApi);
